import AppRouter from './router.js';
import ProjectUtil from './utils/project-util.js';

// app.js
const requiredJSON = {};
const loadedJSON = {};
var fired = false;
const App = {
	init(/*config*/) {
		if (fired) {
			return;
		}
		fired = true;
		this.defineJSON();
	},

	defineJSON() {
		const ts = new Date().getTime();
		const self = this;
		// GlobalsObj.CMS_JSON _should_ be loaded in index.php.  If not, attempt to load it now.
		if (!window.GlobalsObj.hasOwnProperty('CMS_JSON')) {
			requiredJSON.cms = false;
			ProjectUtil.requestAPI('a=all&language=' + /*cookies.get('language') + */ '&v=' + ts, function (response) {
				// done function
				if (response && response.data) {
					loadedJSON.cms = response.data;
					requiredJSON.cms = true;
					self.buildRouter();
				} else {
					console.error('failed to fetch API data');
					// trigger error message
					self.Router.dataError();
				}

			});
		} else {
			requiredJSON.cms = true;
			loadedJSON.cms = window.GlobalsObj.CMS_JSON;
			this.buildRouter();
		}
	},

	buildRouter() {
		let jsonLoaded = true;

		Object.entries(requiredJSON).forEach(([prop, val]) => {
			if (val === false) {
				jsonLoaded = false;
				console.log(`requiredJSON.${prop} is not loaded`);
			}
		});

		// if some required JSON isn't loaded, exit
		if (!jsonLoaded) {
			console.log('json not loaded');
			return;
		}

		// initialize Router
		AppRouter.initialize(loadedJSON);
	}
};

export default App;